import { render, staticRenderFns } from "./ClientsViewClientProjectList.vue?vue&type=template&id=96802f8c"
import script from "./ClientsViewClientProjectList.vue?vue&type=script&lang=js"
export * from "./ClientsViewClientProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports